"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 99;\n"], ["\n  position: relative;\n  z-index: 99;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoySidebarNav = require("buoy-sidebar-nav");

var _buoySidebarNav2 = _interopRequireDefault(_buoySidebarNav);

var _NavBar = require("./components/NavBar");

var _NavBar2 = _interopRequireDefault(_NavBar);

var _buoyConfig = require("buoy-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NavContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__NavContainer",
  componentId: "zqss0p-0"
})(_templateObject);

var UniversalNav = function (_React$Component) {
  _inherits(UniversalNav, _React$Component);

  function UniversalNav(props) {
    _classCallCheck(this, UniversalNav);

    // Brand is kept in state for SSR pages
    var _this = _possibleConstructorReturn(this, (UniversalNav.__proto__ || Object.getPrototypeOf(UniversalNav)).call(this, props));

    _this.componentDidMount = function () {
      // For SSR pages, check brand again once the component mounts
      var brand = _this.props.brand;
      var query = _this.getQueryString();
      var baseUrl = (0, _buoyConfig.getBaseUrl)(brand, _this.props.baseUrl);

      if (brand !== _this.state.brand || baseUrl !== _this.state.baseUrl) {
        _this.setState({
          brand: brand,
          baseUrl: baseUrl,
          config: (0, _buoyConfig.getConfig)(brand, baseUrl)
        });
      }

      if (query !== _this.state.query) {
        _this.setState({ query: query });
      }
    };

    _this.toggle = function () {
      _this.setState({ showSidebar: !_this.state.showSidebar });
    };

    _this.showLink = function (link, loggedIn) {
      if (loggedIn) {
        return link.showIfLoggedIn;
      } else {
        return link.showIfLoggedOut;
      }
    };

    _this.getQueryString = function () {
      if (typeof window !== "undefined") {
        return window.location.search;
      } else {
        return null;
      }
    };

    _this.state = {
      showSidebar: false,
      brand: undefined,
      query: _this.getQueryString(),
      config: (0, _buoyConfig.getConfig)(),
      baseUrl: _buoyConfig.navConfig.brands.default.baseUrl
    };
    return _this;
  }

  _createClass(UniversalNav, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _React$createElement;

      var _props = this.props,
          loggedIn = _props.loggedIn,
          inverse = _props.inverse,
          showTopNavMessage = _props.showTopNavMessage,
          topNavLogoSize = _props.topNavLogoSize,
          topNavTransform = _props.topNavTransform,
          cta = _props.cta,
          alertVariant = _props.alertVariant,
          onAlertClose = _props.onAlertClose,
          showAlertBanner = _props.showAlertBanner,
          brand = _props.brand,
          languageOnChange = _props.languageOnChange,
          showLanguageSelector = _props.showLanguageSelector,
          selectedLanguage = _props.selectedLanguage,
          isConfiguredExperience = _props.isConfiguredExperience,
          landing = _props.landing,
          showLanguageModal = _props.showLanguageModal,
          shouldFocusDropdown = _props.shouldFocusDropdown,
          setFocus = _props.setFocus;


      var config = this.state.config;
      var white = "#FFFFFF";

      var topNavColor = this.props.topNavColor || (inverse ? config.primaryColor : config.top.color || white);
      var burgerColor = this.props.menuIconColor || (inverse ? white : config.primaryColor);
      var poweredByColor = this.props.poweredByColor || (inverse ? white : config.top.poweredByColor || config.primaryColor);
      var topNavGhostButton = this.props.topNavGhostButton || inverse;

      var topNavLinks = this.props.topNavLinks ? (0, _buoyConfig.buildNavLinks)(this.props.topNavLinks, this.props.baseUrl, this.props.actions) : config.top.links;
      topNavLinks = topNavLinks.filter(function (link) {
        return _this2.showLink(link, loggedIn);
      });

      var topCta = (0, _buoyConfig.check_cta_url)(cta);
      var sideCta = (0, _buoyConfig.check_cta_url)(cta);
      if (!topCta) {
        topCta = config.top.cta;
      }
      if (!sideCta) {
        sideCta = config.sidebar.cta;
      }
      var showTopPoweredBy = this.props.showTopPoweredBy || config.top.showPoweredBy;
      var legalItems = this.props.sideMenuLegalLinks ? (0, _buoyConfig.buildLegal)(this.props.sideMenuLegalLinks, this.props.baseUrl) : config.sidebar.legal;
      var sidebarLinks = this.props.sideMenuLinks ? (0, _buoyConfig.buildNavLinks)(this.props.sideMenuLinks, this.props.baseUrl, this.props.actions) : config.sidebar.mainLinks;
      var sidebarMenuLinks = sidebarLinks.filter(function (link) {
        return _this2.showLink(link, loggedIn);
      });
      var topNavLinkColor = this.props.topNavLinkColor || (inverse ? white : null);
      var topNavLinkUnderlineColor = this.props.topNavLinkUnderlineColor || (inverse ? white : null);
      var topNavMessage = showTopNavMessage ? this.props.topNavMessage : null;
      var showSidePoweredBy = this.props.showSidePoweredBy || config.sidebar.showPoweredBy;
      var sideColor = this.props.sideMenuColor || config.primaryColor;
      var showDesktopBurger = config.top.showBurgerIfLoggedIn && loggedIn;
      if (config.top.showBurgerDesktop) showDesktopBurger = config.top.showBurgerDesktop;
      // For MA config - avoided touching code to avoid bugs
      if (config.name === "massachusetts") showDesktopBurger = false;

      // For shadows, config overrides props
      var topNavShadow = this.props.topNavShadow;
      if ("shadow" in config.top) {
        topNavShadow = config.top.shadow;
      }

      var logoType = inverse ? "logo_inverse" : "logo";
      var logoUrl = this.props.logoUrl || config.top.logoUrl || config.baseUrl;

      if (this.state.query && config.top.keepQueryParams) {
        logoUrl += this.state.query;
      }

      if (config.top.disableLogo) logoUrl = null;

      var poweredByUrl = this.props.poweredByUrl || config.top.poweredByUrl || logoUrl;

      var logo = {
        src: this.props.logoImageSrc || _buoyConfig.images[config.name + "_" + logoType + ".svg"],
        size: topNavLogoSize,
        url: logoUrl
      };

      var secondaryLogo = {
        src: this.props.secondaryLogoSrc || (config.top.showSecondaryLogo ? _buoyConfig.images[config.name + "_" + logoType + ".svg"] : null),
        size: topNavLogoSize,
        url: logoUrl
      };

      if (config.top.showLogo && config.top.useBuoyLogo) logo.src = _buoyConfig.images["buoy_logo.svg"];

      if (logo && secondaryLogo && logo.src === secondaryLogo.src) {
        secondaryLogo = null;
      }

      if (logo && !logo.src) logo = null;
      if (secondaryLogo && !secondaryLogo.src) secondaryLogo = null;

      // to show language selector
      var enableLanguageSelection = config.top.enableLanguageSelection || showLanguageSelector;

      return _react2.default.createElement(
        NavContainer,
        null,
        _react2.default.createElement(_NavBar2.default, (_React$createElement = {
          message: topNavMessage,
          logo: logo,
          secondaryLogo: secondaryLogo,
          color: topNavColor,
          links: topNavLinks,
          cta: topCta,
          onBurgerClick: this.toggle,
          burgerColor: burgerColor,
          boxShadow: topNavShadow,
          ghostButton: topNavGhostButton,
          transform: topNavTransform,
          linkColor: topNavLinkColor,
          linkUnderlineColor: topNavLinkUnderlineColor,
          showPoweredBy: showTopPoweredBy,
          poweredByColor: poweredByColor,
          poweredByUrl: poweredByUrl,
          showDesktopBurger: showDesktopBurger,
          baseUrl: this.props.baseUrl,
          brand: this.props.brand,
          alertVariant: alertVariant,
          onAlertClose: onAlertClose,
          showAlertBanner: showAlertBanner
        }, _defineProperty(_React$createElement, "brand", brand), _defineProperty(_React$createElement, "enableLanguageSelection", enableLanguageSelection), _defineProperty(_React$createElement, "languageOnChange", languageOnChange), _defineProperty(_React$createElement, "selectedLanguage", selectedLanguage), _defineProperty(_React$createElement, "isConfiguredExperience", isConfiguredExperience), _defineProperty(_React$createElement, "landing", landing), _defineProperty(_React$createElement, "showLanguageModal", showLanguageModal), _defineProperty(_React$createElement, "shouldFocusDropdown", shouldFocusDropdown), _defineProperty(_React$createElement, "setFocus", setFocus), _React$createElement)),
        _react2.default.createElement(_buoySidebarNav2.default, {
          show: this.state.showSidebar,
          onToggle: this.toggle,
          menuLinks: sidebarMenuLinks,
          cta: sideCta,
          legalItems: legalItems,
          showPoweredBy: showSidePoweredBy,
          poweredByUrl: poweredByUrl,
          color: sideColor,
          isConfiguredExperience: isConfiguredExperience,
          brand: this.props.brand
        })
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var baseUrl = (0, _buoyConfig.getBaseUrl)(props.brand, props.baseUrl);
      if (props.brand !== state.brand) {
        return {
          brand: props.brand,
          baseUrl: baseUrl,
          config: (0, _buoyConfig.getConfig)(props.brand, baseUrl, props.actions)
        };
      }
      return null;
    }
  }]);

  return UniversalNav;
}(_react2.default.Component);

UniversalNav.propTypes = {
  actions: _propTypes2.default.object,
  baseUrl: _propTypes2.default.string.isRequired,
  brand: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  loggedIn: _propTypes2.default.bool,
  prod: _propTypes2.default.bool,
  topNavLogoSize: _propTypes2.default.string,
  topNavColor: _propTypes2.default.string,
  topNavShadow: _propTypes2.default.bool,
  topNavGhostButton: _propTypes2.default.bool,
  topNavTransform: _propTypes2.default.string,
  cta: _propTypes2.default.object,
  showLanguageSelector: _propTypes2.default.bool
};

UniversalNav.defaultProps = {
  actions: {},
  brand: "public",
  loggedIn: false,
  prod: false,
  topNavLogoSize: "small",
  topNavColor: null,
  topNavShadow: true,
  topNavGhostButton: false,
  topNavTransform: null,
  cta: {},
  showLanguageSelector: false
};

exports.default = UniversalNav;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-universal-nav/dist/index.js
// module id = 109
// module chunks = 168707334958949